export default __webpack_public_path__ + "static/tablets-cff1490d66dd17285d1e3dddc39b5912.jpg";